<template>
  <div>
    <div class="text-center">
      <client-plan-form
        v-if="activePlans.length == 0 && !viewOnly"
      ></client-plan-form>
    </div>
    <plans-list
      v-if="activePlans.length > 0"
      :plans="activePlans"
      :active="true"
      :viewOnly="viewOnly"
    ></plans-list>
    <div class="text-center my-3">
      <v-btn
        v-if="activePlans.length > 0 && previousPlans.length > 0"
        @click="showPrevious = !showPrevious"
        text
        small
        color="primary"
        >{{
          Boolean(showPrevious) ? "Hide Previous Plans" : "Show Previous Plans"
        }}</v-btn
      >
    </div>
    <plans-list
      v-if="activePlans.length == 0 || showPrevious"
      :plans="previousPlans"
      :viewOnly="viewOnly"
    ></plans-list>
  </div>
</template>

<script>
import ClientPlanForm from "./client-plan-form";
import ServicePlansTable from "./service-plans-table";
import PlansList from "./plans-list";
export default {
  components: { ClientPlanForm, ServicePlansTable, PlansList },
  props: ["viewOnly"],
  data() {
    return {
      panels: null,
      showPrevious: false,
    };
  },
  computed: {
    activePlans() {
      return this.clientPlans.filter((item) => item.isActive == true) || null;
    },
    clientPlans() {
      return (
        this.$store.state.plansModule.plans.slice().sort((a, b) => {
          return new Date(b.planStartDate) - new Date(a.planStartDate);
        }) || []
      );
    },
    previousPlans() {
      return this.clientPlans.filter((x) => !x.isActive);
    },
  },
};
</script>
